export const MAX_MOBILE_WIDTH = 767
export const MIN_TABLET_WIDTH = 768
export const MAX_TABLET_WIDTH = 1439
export const MIN_DESKTOP_WIDTH = 1440
